<template>
  <CommonLicenseComponentsWrapper
    :component="component"
    licenseName="film-license"
  />
</template>

<script>
import FastTrackPage from './FastTrackPage';
import CommonLicenseComponentsWrapper from '../CommonLicenseComponents/Wrapper';

export default {
  components: {
    FastTrackPage,
    CommonLicenseComponentsWrapper,
  },
  data() {
    return {
      component: FastTrackPage,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/FilmLicenseAgreementFastTrack/index.vue